!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"), require("prop-types"));else if ("function" == typeof define && define.amd) define(["react", "prop-types"], t);else {
    var r = "object" == typeof exports ? t(require("react"), require("prop-types")) : t(e.react, e["prop-types"]);

    for (var n in r) {
      ("object" == typeof exports ? exports : e)[n] = r[n];
    }
  }
}("undefined" != typeof self ? self : this, function (e, t) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 0);
  }([function (e, t, r) {
    "use strict";

    function n(e) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "BoxProps", {
      enumerable: !0,
      get: function get() {
        return o.BoxProps;
      }
    }), Object.defineProperty(t, "ExtendableBox", {
      enumerable: !0,
      get: function get() {
        return o.ExtendableBox;
      }
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function get() {
        return o.default;
      }
    });

    var o = function (e) {
      if (e && e.__esModule) return e;
      if (null === e || "object" !== n(e) && "function" != typeof e) return {
        default: e
      };
      var t = u();
      if (t && t.has(e)) return t.get(e);
      var r = {},
          o = Object.defineProperty && Object.getOwnPropertyDescriptor;

      for (var f in e) {
        if (Object.prototype.hasOwnProperty.call(e, f)) {
          var l = o ? Object.getOwnPropertyDescriptor(e, f) : null;
          l && (l.get || l.set) ? Object.defineProperty(r, f, l) : r[f] = e[f];
        }
      }

      r.default = e, t && t.set(e, r);
      return r;
    }(r(1));

    function u() {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap();
      return u = function u() {
        return e;
      }, e;
    }
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = u(r(2)),
        o = u(r(3));

    function u(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function f() {
      return (f = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function l(e, t) {
      if (null == e) return {};

      var r,
          n,
          o = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            o = {},
            u = Object.keys(e);

        for (n = 0; n < u.length; n++) {
          r = u[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
        }

        return o;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var u = Object.getOwnPropertySymbols(e);

        for (n = 0; n < u.length; n++) {
          r = u[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
        }
      }

      return o;
    }

    function i(e, t) {
      if (null != e.as) {
        var r = e.as,
            o = l(e, ["as"]);
        return n.default.createElement(r, f({}, o, {
          ref: t
        }));
      }

      return null != e.href ? n.default.createElement("a", f({}, e, {
        ref: t
      })) : n.default.createElement("div", f({}, e, {
        ref: t
      }));
    }

    i.displayName = "InlineBox";
    var a = n.default.forwardRef(i);
    a.displayName = "Box", a.propTypes = {
      as: o.default.oneOfType([o.default.elementType, o.default.element, o.default.func]),
      href: o.default.string
    };
    var p = a;
    t.default = p;
  }, function (t, r) {
    t.exports = e;
  }, function (e, r) {
    e.exports = t;
  }]);
});